import { FunctionComponent, PropsWithChildren } from "react";

export interface IconProps {
    /**
     * Class name of the tabs.
     */
    className?: string;
}

export const Icon: FunctionComponent<PropsWithChildren<IconProps>> = ({ className, children }) => {
    return (
        <svg
            className={className}
            aria-hidden="true"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
        >
            {children}
        </svg>
    );
};
